<template>
  <div ref="myTitleRef" class="title_box">
    <div v-if="isShow" class="title slide-in-right" :class="{ 'white_title': isWhite}">
      {{ title }}
    </div>
    <div v-if="isShow" class="en-title slide-in-bottom">
      <div class="line" :class="{ 'white_line': isWhite}"></div>
      <div class="text" :class="{ 'white_text': isWhite}">{{ enTitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myTitle",
  props: {
    title: {
      type: String,
      default: "title",
    },
    enTitle: {
      type: String,
      default: "enTitle",
    },
    isWhite:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
    this.observeVisibility();
  },
  methods: {
    observeVisibility() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 组件进入视口时执行的操作
            this.isShow = true;
          } else {
            this.isShow = false;
          }
        });
      });

      observer.observe(this.$refs.myTitleRef);
    },
  },
};
</script>

<style scoped lang="scss">

.title_box{
  min-height: 78px;
}
.title {
font-family: PingFang SC;
font-weight: 400;
font-size: 36px;
color: #222222;
}
.white_title{
  color: white !important;
}

.en-title {
  margin-top: 14px;
  display: flex;
  align-items: center;

font-family: PingFangSC;
font-weight: 300;
font-size: 24px;
color: #35A79B;
  .line {
    width: 90px;
    height: 2px;
    background: #35a89c;
    margin-right: 12px;
  }
  .white_line{
    background:white !important;
  }
  .text {
    letter-spacing: 3px;
  }
  .white_text{
    color: white !important;
  }
}
@keyframes slideInRight {
    from {
      transform: translateX(-50%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .slide-in-right {
    animation: slideInRight 0.8s ease-out forwards;
    opacity: 0;
  }

  @keyframes slideInBottom {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  .slide-in-bottom {
    animation: slideInBottom 0.8s ease-out forwards;
    opacity: 0;
  }
</style>
